
export default {
  name: "UiReadMore",
  props: {
    maxHeight: {
      type: String,
      default: "100px",
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    mobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: this.expanded,
      showReadMoreButton: false,
      resizeTimeout: null,
    };
  },
  computed: {
    contentStyle() {
      if (this.isExpanded) {
        return {};
      }

      return {
        maxHeight: this.maxHeight,
        overflow: "hidden",
      };
    },
  },
  watch: {
    expanded(newVal) {
      this.isExpanded = newVal;
    },
    maxHeight() {
      this.checkContentHeight();
    },
  },
  mounted() {
    this.checkContentHeight();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  },
  methods: {
    checkContentHeight() {
      this.$nextTick(() => {
        if (this.$refs.contentRef) {
          const content = this.$refs.contentRef;
          const scrollHeight = content.scrollHeight;
          this.showReadMoreButton = scrollHeight > parseInt(this.maxHeight);
          if (!this.showReadMoreButton) {
            this.isExpanded = true;
          }
        }
      });
    },
    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        this.checkContentHeight();
      }, 100);
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      this.$emit("toggle", this.isExpanded);
    },
  },
};
